import React from 'react';
import { Empty, Spin, Alert } from 'antd';
import './ShipToDetailsCard.less';

export default function ShipToDetailsCard({ data, loading, error, hasSearched }) {
  if (loading) {
    return (
      <div className="shipto-details-card">
        <Spin tip="Loading..." />
      </div>
    );
  }

  if (error) {
    return (
      <div className="shipto-details-card">
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
        />
      </div>
    );
  }

  if (!hasSearched || !data) {
    return (
      <div className="shipto-details-card">
        <Empty 
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description="No data available. Please perform a search above."
        />
      </div>
    );
  }

  const formatTime = (time) => {
    if (!time) return '-';
    
    const timeStr = time.toString().replace(/:/g, '');
    let hours, minutes;
    
    if (timeStr.length >= 4) {
      hours = parseInt(timeStr.substring(0, 2));
      minutes = timeStr.substring(2, 4);
    } else {
      return time; // Return as-is if format is unexpected
    }
    
    if (isNaN(hours) || hours < 0 || hours > 23) return time;
    
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours === 0 ? 12 : hours > 12 ? hours - 12 : hours;
    
    return `${displayHours}:${minutes} ${period}`;
  };

  const detailBoxes = [
    // { label: 'BILL TO', value: 'custom', isHighlight: true, key: 'billTo' }, // no mapping
    { label: 'SHIP-TO', value: data.customerId, isHighlight: true, key: 'customerId' },
    // { label: 'PRIMARY SHIP-TO', value: data.substitutedFlag === 'Y' ? 'Yes' : 'No', key: 'primaryShipTo' }, // no mapping
    { label: 'NAME', value: data.customerName, key: 'customerName' },
    
    { label: 'ADDRESS', value: data.address1, key: 'address' },
    // { label: 'CITY/STATE', value: `${data.city || ''}`, key: 'cityState' },
    { 
      label: 'CITY/STATE', 
      value: (data.city && data.state) ? `${data.city}, ${data.state}` : data.city || data.state || '-', 
      key: 'cityState' 
    },
    { label: 'ZIP CODE', value: data.zipcode, key: 'zipCode' },
    { label: 'TERRITORY', value: data.territory, key: 'territory' },
    
    { label: 'ACCOUNT TYPE', value: data.accountType, key: 'accountType' },
    { label: 'SHIP-TO STATUS', value: data.shipToCustomerStatus, key: 'shipToStatus' },
    // { label: 'SHIP-TO STATUS', value: getShipToStatus(data.shipToCustomerStatus), key: 'shipToStatus' },
    {label:'SUBSTITUTIONS', value: data.substitutedFlag, key:'substitutions'},
    // { label: 'SUBSTITUTIONS', value: getSubstitutions(data.substitutedFlag), key: 'substitutions' },
   // { label: 'RESTRICT', value: data.restrictFlag === 'Y' ? 'Yes' : 'No', key: 'restrict' },// no mapping
    
    // { label: 'IMMEDIATE ALLOCATION', value: 'No', key: 'immediateAllocation' }, // no mapping
    // { label: 'FORCED SUB', value: 'No', key: 'forcedSub' }, // no mapping
    // { label: 'CHART TYPES', value: 'Standard', key: 'chartTypes' }, // no mapping
    // { label: 'PALLETIZED', value: 'Yes', key: 'palletized' }, // no mapping
    
    // { label: 'KEYDROP', value: 'No', key: 'keydrop' }, // no mapping
    //{ label: 'DLV DAY', value: getDayName(data.designatedDeliveryDay), key: 'dlvDay' }, //check days with backend
    { label: 'DLV DAY', value: data.designatedDeliveryDay, key: 'dlvDay' },
    { label: 'CUTOFF TIMEZONE', value: data.cutoff, key: 'cutoffTimezone' }, // no mapping
    // { label: 'SALE CALL', value: 'No', key: 'saleCall' }, // no mapping
    
    // { label: 'BUSK DAYS', value: '5', key: 'buskDays' },  //no mapping
    // { label: 'DAILY OVERRIDE', value: 'No', key: 'dailyOverride' },  // no mapping
    { label: 'BACK OPEN', value: formatTime(data.storeOpenTime), key: 'storeOpenTime' },
    { label: 'DOOR CLOSE', value: formatTime(data.storeCloseTime), key: 'storeCloseTime' },
    
    { label: 'TIME 1 STR', value: formatTime(data.timeWindow1Start), key: 'time1Str' }, 
    { label: 'STP', value: formatTime(data.timeWindow1Stop), key: 'stp' }, 

    

 
  ];

  return (
    <div className="shipto-details-card">
      <div className="details-grid">
        {detailBoxes.map((box) => (
          <div key={box.key} className="detail-box">
            <div className="detail-label">{box.label}</div>
            <div className={`detail-value ${box.isHighlight ? 'highlight-blue' : ''}`}>
              {box.value || '-'}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}


